import LoggedInAsBrandBadge from './LoggedInAsBrandBadge';

export default LoggedInAsBrandBadge;
